import { render, staticRenderFns } from "./ApplicationsDetailsCredentials.vue?vue&type=template&id=9274e120&scoped=true"
import script from "./ApplicationsDetailsCredentials.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetailsCredentials.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetailsCredentials.vue?vue&type=style&index=0&id=9274e120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9274e120",
  null
  
)

export default component.exports